import { render, staticRenderFns } from "./AdressesItem.vue?vue&type=template&id=7e7fbae2&scoped=true&"
import script from "./AdressesItem.vue?vue&type=script&lang=js&"
export * from "./AdressesItem.vue?vue&type=script&lang=js&"
import style1 from "./AdressesItem.vue?vue&type=style&index=1&id=7e7fbae2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7fbae2",
  null
  
)

export default component.exports